import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import {groupBy} from 'lodash';

import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import Typography from '../../../Typography'

import ListItemSearchComponent from './ListItem';
import RelayListItemComponent from './ListItem.relay';

const styles = theme => ({
  list_container: {
    display:'flex',
    flexDirection: 'column',
    flex:1,
    minHeight:0,
    width:'100%',
  },
  content: {
    display:"flex",
    flexDirection:'column',
    flex:1,
    overflowY:'auto',
    overflowX: 'hidden',
    width:'100%',
    padding: `0 0 ${theme.spacing_unit.xs}px`
  },
  root_list_item: {
    cursor: "pointer",
    padding: theme.margins.xs,
    '&:hover': {
      background: theme.palette.lightGrey,
    },
  },
  header_list_item: {
    '&:hover': {
      background: "none",
    },
    padding: `${theme.spacing_unit.xs}px ${theme.margins.xs}px ${theme.spacing_unit.xs}px ${theme.margins.xs + 1}px`,
    '&:first-child': {
      padding: `${theme.margins.md}px ${theme.margins.xs}px ${theme.spacing_unit.xs}px ${theme.margins.xs + 1}px`,
    }
  },
  indent_list: {
    paddingLeft: theme.margins.lg
  }

});

function check_for_not_null(value) {
  return value === "null" || value === "undefined"
          ? ""
          : value
}


const SimpleList = ({
    suggestions:server_suggestions,
    classes,
    group_suggestions_by,
    default_group_suggestions_by,
    should_group,
    fetch_type,
    ...list_item_props
  }) => {

  const grouped_suggestions = React.useMemo(() => {
    return should_group && groupBy(server_suggestions, group_suggestions_by)
  },[group_suggestions_by, should_group, server_suggestions])

  const suggestions_array = should_group ? Object.keys(grouped_suggestions) : [server_suggestions];

  const ListItemComponent = React.useMemo(() => fetch_type === "no-fetch"
    ? ListItemSearchComponent
    : RelayListItemComponent
  ,[fetch_type]);

  if (!Boolean(suggestions_array && suggestions_array.length)) { return null; }

  return (
    <div className = {classes.list_container}>
        <List className = {classes.content}>
        {
          suggestions_array.map((suggestion, idx) => {
            return (
                <React.Fragment key = {`list-itme-header-${idx}}`}>
                {
                  should_group && check_for_not_null(suggestion)
                  ?
                  <ListItem classes = {{root: classes.header_list_item }}>
                    <Typography type = "body1" font_weight = {600}>
                      { suggestion }
                    </Typography>
                  </ListItem>
                  : null
                }
                {
                  grouped_suggestions[suggestion].map((item, index) => (
                    <ListItemComponent
                        key = {`simple-list-item-${item.region}-${index}`}
                        item = {item}
                        className = {should_group && suggestion && classes.indent_list}
                        default_selected = {idx === 0 && index === 0}
                        {...list_item_props}
                    />
                  ))
                }
              </React.Fragment>
            )
          })
        }
      </List>
    </div>
  )
};

SimpleList.propTypes = {
  classes: PropTypes.object.isRequired,
  suggestions: PropTypes.array,
  group_suggestions_by: PropTypes.string,
  default_group_suggestions_by: PropTypes.string,
  fetch_type: PropTypes.oneOf(["fetch","re-fetch","no-fetch"]),
  should_group: PropTypes.bool
}

SimpleList.defaultProps = {
  group_suggestions_by: "region",
  default_group_suggestions_by: "Sub-org Master",
  should_group: true
}

export default React.memo(withStyles(styles)(SimpleList));
